import { Buffer } from 'buffer'

/**
 * Base64 Decode unicode string.
 *
 * Source: https://github.com/auth0/jwt-decode/blob/542195dd291645b03561b53f8bbf09fd11587c52/build/jwt-decode.js#L64
 *
 * @param {string} str String to decode
 */
const b64DecodeUnicode = (str) => {
  return decodeURIComponent(
    // atob(str).replace(/(.)/g, function (m, p) {
    Buffer.from(str, 'base64').replace(/(.)/g, function (m, p) {
      var code = p.charCodeAt(0).toString(16).toUpperCase()
      if (code.length < 2) {
        code = '0' + code
      }
      return '%' + code
    })
  )
}

/**
 * Base64 URL Decode function.
 *
 * Source: https://github.com/auth0/jwt-decode/blob/542195dd291645b03561b53f8bbf09fd11587c52/build/jwt-decode.js#L64
 *
 * @param {string} str String to decode
 */
const base64_url_decode = (str) => {
  var output = str.replace(/-/g, '+').replace(/_/g, '/')
  switch (output.length % 4) {
    case 0:
      break
    case 2:
      output += '=='
      break
    case 3:
      output += '='
      break
    default:
      throw Error('Illegal base64url string!')
  }

  try {
    return b64DecodeUnicode(output)
  } catch (err) {
    // return atob(output)
    return Buffer.from(output, 'base64')
  }
}

/**
 * Check if auth token is expired.
 *
 * @return true if the token is expired.
 */
export const isAuthTokenExpired = (jwtAuthToken) => {
  if (jwtAuthToken === null || jwtAuthToken === undefined) {
    return true
  }

  const { exp } = JSON.parse(base64_url_decode(jwtAuthToken.split('.')[1]))
  const now = parseInt(Date.now().toString().slice(0, -3))

  return exp <= now
}
